import { call, put, takeLatest } from "@redux-saga/core/effects";
import { CheckIncustomerConstant } from "./CheckInCustomerConstant";
import { CheckIncustomerApi } from "./CheckInCustomerApi";
import { CheckIncustomerParser } from "./CheckInCustomerParser";
function* getCheckIncustomerData({payload}) {
  let {  chargingStation,
    model,
    connector,
    manufacturer,
    startDate,
    endDate,
    search,
    limit,
    page,
    filter
  } = payload;

  try {
    yield put({ type: CheckIncustomerConstant.CHECKIN_CUSTOMER_REQUEST });
    const res = yield call(CheckIncustomerApi.getCheckIncustomerData, {
      chargingStation,
  model,
  connector,
  manufacturer,
  startDate,
  endDate,
  search,
  page,
  limit,
  filter
    });
    const payload = CheckIncustomerParser.getCheckIncustomerParser(res);
    yield put({
      type: CheckIncustomerConstant.CHECKIN_CUSTOMER_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: CheckIncustomerConstant.CHECKIN_CUSTOMER_RESPONSE,
      payload: [],
    });
  }
}
function* postCheckinDetailsData({payload}) {
  try {
    yield put({
      type: CheckIncustomerConstant.ADD_CHECKIN_CUSTOMER_DETAIL_REQUEST,
    });
   
    const res = yield call(CheckIncustomerApi.AddCheckinCostomerApi, payload);

    yield put({
      type: CheckIncustomerConstant.ADD_CONNECTOR_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: CheckIncustomerConstant.ADD_CHECKIN_CUSTOMER_DETAIL_RESPONSE,
      payload: [],
    });
  }
}
function* getchecinCustomerbyId({ payload} ) {
  // const { id } = payload;
 
  try {
    yield put({
      type: CheckIncustomerConstant.CHECKIN_CUSTOMER_DETAILS_BY_ID_REQUEST,
    });
    const res = yield call(CheckIncustomerApi.checkinCustomerbyId,  payload );
    yield put({
      type: CheckIncustomerConstant.CHECKIN_CUSTOMER_DETAILS_BY_ID_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: CheckIncustomerConstant.CHECKIN_CUSTOMER_DETAILS_BY_ID_RESPONSE,
      payload: {},
    });
  }
}

export function* CheckIncustomerDataSaga() {
  yield takeLatest(CheckIncustomerConstant.CHECKIN_CUSTOMER_SAGA, getCheckIncustomerData);
  yield takeLatest(CheckIncustomerConstant.ADD_CHECKIN_CUSTOMER_DETAIL_SAGA, postCheckinDetailsData);
  yield takeLatest(CheckIncustomerConstant.CHECKIN_CUSTOMER_DETAILS_BY_ID_SAGA, getchecinCustomerbyId);
}
